import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { InvalidSearchApi, InvalidSearchApiImpl } from './apis';

/** 专利无效检索模块的依赖注入注册。 */
export const invalidSearchContainer = new ContainerModule((bind) => {
    bind(InvalidSearchApi).to(InvalidSearchApiImpl);
});
